// extracted by css-extract-rspack-plugin
var _1 = "container__NaCnV";
var _2 = "delete__ocFPF";
var _3 = "details-container__UjLV_";
var _4 = "preview__KAXmJ";
var _5 = "preview__container__ZAyAh";
var _6 = "preview__details__RzIeA";
var _7 = "preview__details__label__WTT4r";
var _8 = "preview__details__value___HrU0";
var _9 = "thumbnail__RTrFu";
export { _1 as "container", _2 as "delete", _3 as "details-container", _4 as "preview", _5 as "preview__container", _6 as "preview__details", _7 as "preview__details__label", _8 as "preview__details__value", _9 as "thumbnail" }
export default { "container": _1, "delete": _2, "details-container": _3, "preview": _4, "preview__container": _5, "preview__details": _6, "preview__details__label": _7, "preview__details__value": _8, "thumbnail": _9 }
